var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal"},[_c('h4',[_vm._v(_vm._s(_vm.message))]),_c('div',{staticClass:"action"},[_c('button',{staticClass:"btn btn-green",on:{"click":_vm.yes}},[_vm._v("Yes")]),_c('button',{staticClass:"btn btn-grey",on:{"click":_vm.no}},[_vm._v("Cancel")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }